import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {
  path,
  mergeDeepLeft,
  clone,
  findIndex,
  propEq,
  map,
  filter,
} from 'ramda';
import Input from '../../common/Input';
import ReactSelectWrapper from '../../common/ReactSelectWrapper';
import MultiSelect from '../../common/MultiSelect';
import fields from './fields';
import Breadcrumbs from '../../common/Breadcrumbs';
import { processFields } from '../../utils/prePost';
import { validateFields } from '../../utils/validate';
import '../../css/forms/default-forms.css';
import { fetchUsersByRoleId } from '../../api/users';
import { createShop } from '../../api/shops';
import { addNotification as notify } from 'reapop';

export class AddShop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      errors: [],
      fields: fields,
    };
    this.submit = this.submit.bind(this);
    this.changeFormValue = this.changeFormValue.bind(this);
    this.cancel = this.cancel.bind(this);
    this.getOwnersList = this.getOwnersList.bind(this);
    this.getWorkersList = this.getWorkersList.bind(this);
    this.convertWorkerList = this.convertWorkerList.bind(this);
    this.addNotification = this.addNotification.bind(this);
  }

  componentWillMount() {
    this.props.getOwners();
    this.props.getWorkers();
  }

  submit(e) {
    e.preventDefault();
    let result = validateFields(this.state.fields);
    if (result.check === false) {
      this.setState({
        fields: result.fields,
      });
    } else {
      let data = processFields(this.state.fields);
      data = this.convertWorkerList(data)
      
      if(data.workers.length === 0) {
        this.addNotification();
      }else {
        this.props.saveForm(data);  
      }
    }
    return false;
  }

  addNotification() {    
    this.props.addNotification();    
  }

  changeFormValue(field, newObject) {
    let stateClone = clone(this.state);
    stateClone.fields[field] = newObject;
    this.setState(mergeDeepLeft(stateClone, this.state));
  }

  convertWorkerList(data) {
    let selectedWorkers = filter(item => item.checked, data.workers);
    data.workers = map(item => item.value, selectedWorkers);

    data.workers = data.workers.join(',');
    return data;
  }

  cancel() {
    this.props.goToShops();
  }

  parseList(arr) {
    const arrCustomers = [];

    if (arr) {
      for (let i = 0; i < arr.length; i++) {
        arrCustomers.push({
          value: arr[i].id,
          checked: false,
          label: arr[i].firstname + ' ' + arr[i].lastname,
        });
      }
    }

    return arrCustomers;
  }

  getOwnersList() {
    const ownerList = path(['users', 'roleList', 'admin'], this.props) || [];
    return this.parseList(ownerList);
  }

  getWorkersList() {
    const workerList = path(['users', 'roleList', 'worker'], this.props) || [];
    return this.parseList(workerList);
  }

  render() {
    return (
      <div className="row">
        <div className="col">
          <Breadcrumbs list={[
           { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
           { url: '/pages/shops', icon: 'shop', name: 'Shops' },
           { icon: 'add_to_photos', name: 'Add Shop' },
          ]} />
          <div className="card rounded">
            <div className="card-header rounded-top">
              Add Shop
            </div>
            <div className="card-block">
              <div className="col-12" style={{ paddingBottom: '40px' }}>
                <button
                  className={'btn btn-danger btn-outline float-right'}
                  style={{ marginLeft: '10px' }}
                  onClick={this.cancel}
                >
                  <i className="fa fa-remove"></i>
                  <span style={{ paddingLeft: '3px' }}>Cancel</span>
                </button>
                <button className={'btn btn-success btn-outline float-right'} onClick={this.submit}>
                  <i className="fa fa-check"></i>
                  <span style={{ paddingLeft: '3px' }}>Save & Continue</span>
                </button>
              </div>
              <form onSubmit={this.submit}>
                <div className="col-12">
                  <Input
                    field={this.state.fields['name']}
                    onChange={this.changeFormValue}
                  />
                  <ReactSelectWrapper
                    options={this.getOwnersList()}
                    field={this.state.fields['owner']}
                    onChange={this.changeFormValue}
                  />
                  <MultiSelect
                    options={this.state.fields.workers.value.length > 0 ? this.state.fields.workers.value : this.getWorkersList()}
                    field={this.state.fields['workers']}
                    onChange={this.changeFormValue}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    goToShops: () => {
      dispatch(push('/pages/shops'));
    },
    getOwners: () => {
      fetchUsersByRoleId(1, 'admin')(dispatch);
    },
    saveForm: (data) => {
      createShop(data)(dispatch);
    },
    getWorkers: () => {
      fetchUsersByRoleId(4, 'worker')(dispatch);
    },
    addNotification: () => {
      dispatch(notify({
        title: 'Shops',
        message: 'Any worker should be selected',
        status: 'error',
        position: 'tr',
        dismissible: true,
        dismissAfter: 3000,
      }));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddShop);



// WEBPACK FOOTER //
// ./src/containers/AddShop/index.js